var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"invoicing-tools"},[_c('el-col',{attrs:{"xs":24,"sm":12}},[_c('outstanding-invoices')],1),_c('el-col',{attrs:{"xs":24,"sm":12}},[_c('automated-collections')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }